import React, { Component } from "react";
import { connect } from "react-redux";
import Button from "@material-ui/core/Button";
import CategoryMiddleware from "../../../store/middleware/categoryMiddleware";
import BrandsMiddleware from "../../../store/middleware/brandsMiddleware";
import SkusMiddleware from "../../../store/middleware/skusMiddleware";
import BaselineTotalDemandMiddleware from '../../../store/middleware/baselineTotalDemandMiddleware';
import "../../../assets/style/sfos.styles.scss";
import "./BaselineTotalDemand.styles.scss";
import { Loader } from "../../../components/loader";
import { compare } from '../../../prat_screen/gt/validation/sort';
import CustomToast from '../../../util-functions/customToast.jsx';
import CustomSelect from "../../../components/common/select/Select";
import TotalBaselineTable from '../../../components/total-baseline-table/totalBaselineTable';
import BaselineVolumeLineChart from '../../../components/line-charts/baseline-line-charts/baselineVolumeLineChart';
import BaselineVolumeQtrLineChart from '../../../components/line-charts/baseline-line-charts/baselineVolumeQtrLineChart';
import BaselineTimeLineChart from '../../../components/line-charts/baseline-line-charts/baselineTimelineLineChart';
import BaselineTrendLineChart from '../../../components/line-charts/baseline-line-charts/baselineTrendLineChart';
import BaselineSeasonalLineChart from '../../../components/line-charts/baseline-line-charts/baselineSeasonalLineChart';
import BaselineResidualLineChart from '../../../components/line-charts/baseline-line-charts/baselineResidualLineChart';
import DATA from '../../../assets/data';

export class BaselineTotalDemand extends Component {
  constructor(props) {
    super(props);
    this.state = {
      myBrands: [],
      mySkus: [],
      selectedCategory: '',
      selectedBrand: '',
      selectedSku: '',
      isLoadingInitial: true,
    };
  }

  componentDidMount() {
    if (!navigator.onLine) {
      CustomToast('error', 'You are Offline')
      return;
    }
    this.props.getCategory();
    this.props.getBrands();
    this.props.getSkus();
  }

  getDataOnComponentMount = () => {
    this.setState(
      {
        selectedCategory: this.props.category[0].guid,
      },
      () => {
        this.props.getBaselineTotalDemand(
          this.state.selectedCategory,
          this.state.selectedBrand,
          this.state.selectedSku
        );
        this.props.getBaselineTotalDemandTimeLine(
          this.state.selectedCategory,
          this.state.selectedBrand,
          this.state.selectedSku
        );
        this.setState({ isLoadingInitial: false });
      })
  };

  handleFilteredBrands = () => {
    const { selectedCategory } = this.state;
    const { brands } = this.props;
    let filteredbrands = [];
    if (selectedCategory) {

      filteredbrands = brands.filter((item) => item.Category === selectedCategory)

      this.setState({
        myBrands: filteredbrands,
      });
    }
  };

  handleFilteredSkus = () => {
    const { selectedBrand } = this.state;
    const { skus } = this.props;
    let filteredSkus = [];
    if (selectedBrand) {

      filteredSkus = skus.filter((item) => item.Brand === selectedBrand)

      this.setState({
        mySkus: filteredSkus,
      });
    }
  };

  handleChange = (selectedValue) => {
    if (selectedValue === '') {
      this.setState({
        selectedCategory: '',
        myBrands: [],
        selectedBrand: '',
        selectedSku: '',
        mySkus: [],
      });
    } else {

      this.setState({
        selectedCategory: selectedValue.value,
        selectedBrand: '',
        selectedSku: ''
      }, () => {
        this.handleFilteredBrands();
      });
    }
  };

  handleBrandChange = (selectedValue) => {
    if (selectedValue === '') {
      this.setState({
        selectedBrand: '',
        selectedSku: '',
        mySkus: [],
      });
    } else {

      this.setState({
        selectedBrand: selectedValue.value,
        selectedSku: ''
      }, () => {
        this.handleFilteredSkus();
      });
    }
  };

  handleSkus = (selectedValue) => {
    if (selectedValue === '') {
      this.setState({
        selectedSku: '',
      });
    } else {

      this.setState({ selectedSku: selectedValue.value });
    }
  };

  handleSubmit = (e) => {
    const {
      selectedCategory,
      selectedBrand,
      selectedSku,
    } = this.state;
    this.props.getBaselineTotalDemand(
      selectedCategory,
      selectedBrand,
      selectedSku,
    );
    this.props.getBaselineTotalDemandTimeLine(
      this.state.selectedCategory,
      this.state.selectedBrand,
      this.state.selectedSku
    );
  };

  componentDidUpdate(prevProps, prevState) {
    if ((prevProps.category !== this.props.category)) {
      this.getDataOnComponentMount();
    }
    if (prevProps.brands !== this.props.brands) {
      this.handleFilteredBrands();
    }
  }

  render() {
    const { category } = this.props;
    return (
      <div className="page-container">
        {
          this.state.isLoadingInitial ||
            this.props.isBaselineTotalDemandLoading ||
            this.props.isBaselineTotalDemandTimelineLoading
            ? (
              <Loader flag={true} />
            ) : (
              <>
                <div className="heading-and-download-container">
                  <span className="component-heading">Baseline Total Demand</span>
                </div>

                {/* Filter section start */}
                <div className="select-container">
                  <div className="filters-container-only">
                    <CustomSelect.MyCustomSelect
                      placeholder={"Category"}
                      className='filter-css'
                      allowSelectAll={false}
                      isMulti={false}
                      options={
                        category
                          ? category.sort(compare).map((item) => {
                            return {
                              value: item.guid,
                              label: item.Name,
                            };
                          })
                          : []
                      }
                      onChange={this.handleChange}
                      value={
                        category
                          ? category
                            .filter((item) => {
                              return this.state.selectedCategory === item.guid;
                            })
                            .map((item) => {
                              return {
                                value: item.guid,
                                label: item.Name,
                              };
                            })
                          : []
                      }
                    />

                    <CustomSelect.MyCustomSelect
                      placeholder={"Brands"}
                      className='filter-css'
                      allowSelectAll={false}
                      isMulti={false}
                      options={
                        this.state.myBrands.length !== 0
                          ? this.state.myBrands.sort(compare).map((item) => ({
                            value: item.guid,
                            label: item.Name,
                          }))
                          : []
                      }
                      onChange={this.handleBrandChange}
                      value={this.state.myBrands
                        .filter((item) => {
                          return this.state.selectedBrand === item.guid;
                        })
                        .map((item) => {
                          return {
                            value: item.guid,
                            label: item.Name,
                          };
                        })}
                    />

                    <CustomSelect.MyCustomSelect
                      placeholder={"MSKUs"}
                      className='filter-css'
                      allowSelectAll={false}
                      isMulti={false}
                      options={
                        this.state.mySkus.length !== 0
                          ? this.state.mySkus.sort(compare).map((item) => ({
                            value: item.guid,
                            label: item.Description,
                          }))
                          : []
                      }
                      onChange={this.handleSkus}
                      value={this.state.mySkus
                        .filter((item) => {
                          return this.state.selectedSku === item.guid;
                        })
                        .map((item) => {
                          return {
                            value: item.guid,
                            label: item.Description,
                          };
                        })}
                    />

                  </div>

                  <Button
                    style={{ marginBottom: 10 }}
                    variant="outlined"
                    className="submit-btn"
                    onClick={(e) => this.handleSubmit(e)}
                  >
                    SUBMIT
              </Button>

                </div>
                {/* Filter section end */}

                <div className="baseline-table-container">
                  <span className="baseline-table-heading">Total Baseline Value</span>
                  <div style={{ display: 'flex' }}>
                    <TotalBaselineTable
                      FlexGrow={2}
                      tableWidth={'54%'}
                      header={[{ name: 'Year' }, ...DATA.QUARTER_MONTHS]}
                      headerBg={'#0353a4'}
                      headerFg={'#ffffff'}
                      data={this.props?.baselineTotalDemand ? this.props?.baselineTotalDemand.data : []}
                      normalRow={true}
                      growthRow={true}
                      cagrRow={true}
                    />

                    <TotalBaselineTable
                      FlexGrow={1}
                      tableWidth={'22%'}
                      header={[{ name: 'Year' }, ...DATA.Quarterdata]}
                      headerBg={'#023e7d'}
                      headerFg={'#ffffff'}
                      data={this.props?.baselineTotalDemand ? this.props?.baselineTotalDemand.data : []}
                      normalQtrRow={true}
                      growthQtrRow={true}
                      cagrQtrRow={true}
                    />

                    <TotalBaselineTable
                      FlexGrow={0}
                      header={[{ name: 'Total' }]}
                      headerBg={'#3b4861'}
                      headerFg={'#e6e6e7'}
                      data={this.props?.baselineTotalDemand ? this.props?.baselineTotalDemand.data : []}
                      totalNormalRow={true}
                      totalGrowthRow={true}
                      totalCAGRRow={true}
                    />
                  </div>
                </div>

                <div className="baseline-table-container">
                  <span className="baseline-table-heading">AWS</span>
                  <div style={{ display: 'flex' }}>
                    <TotalBaselineTable
                      FlexGrow={2}
                      tableWidth={'54%'}
                      header={[{ name: 'Year' }, ...DATA.QUARTER_MONTHS]}
                      headerBg={'#0353a4'}
                      headerFg={'#ffffff'}
                      data={this.props?.baselineTotalDemand ? this.props?.baselineTotalDemand.data : []}
                      normalAWSRow={true}
                    />

                    <TotalBaselineTable
                      FlexGrow={1}
                      tableWidth={'22%'}
                      header={[{ name: 'Year' }, ...DATA.Quarterdata]}
                      headerBg={'#023e7d'}
                      headerFg={'#ffffff'}
                      data={this.props?.baselineTotalDemand ? this.props?.baselineTotalDemand.data : []}
                      normalAWSQtrRow={true}
                    />

                    <TotalBaselineTable
                      FlexGrow={0}
                      header={[{ name: 'Total' }]}
                      headerBg={'#3b4861'}
                      headerFg={'#e6e6e7'}
                      data={this.props?.baselineTotalDemand ? this.props?.baselineTotalDemand.data : []}
                      totalNormalAWSRow={true}
                    />
                  </div>
                </div>

                <div style={{ display: 'flex' }}>

                  <div className="baseline-table-container" style={{ marginRight: '8px', width: '60%', flexGrow: 2 }}>
                    <span className="baseline-table-heading">Month on Month Upsurge/Dip</span>
                    <div style={{ display: 'flex' }}>
                      <TotalBaselineTable
                        FlexGrow={1}
                        tableWidth={'100%'}
                        header={[{ name: 'Year' }, ...DATA.QUARTER_MONTHS]}
                        headerBg={'#0353a4'}
                        headerFg={'#ffffff'}
                        data={this.props?.baselineTotalDemand ? this.props?.baselineTotalDemand.data : []}
                        normalDipRow={true}
                        avgRow={true}
                      />
                    </div>
                  </div>

                  <div className="baseline-table-container" style={{ width: '20%', flexGrow: 1 }}>
                    <span className="baseline-table-heading">Quarter on Quarter Upsurge/Dip</span>
                    <div style={{ display: 'flex' }}>
                      <TotalBaselineTable
                        FlexGrow={1}
                        tableWidth={'100%'}
                        header={[{ name: 'Year' }, ...DATA.Quarterdata]}
                        headerBg={'#023e7d'}
                        headerFg={'#ffffff'}
                        data={this.props?.baselineTotalDemand ? this.props?.baselineTotalDemand.data : []}
                        normalDipQtrRow={true}
                        average2YearDipQtrRow={true}
                        average3YearDipQtrRow={true}
                      />
                    </div>
                  </div>

                </div>

                {/* ********Graphs Section******** */}

                <div style={{ display: 'flex' }}>

                  <div className="baseline-table-container" style={{ marginRight: '8px', width: '60%', flexGrow: 2 }}>
                    <span className="baseline-table-heading">Monthly Baseline</span>
                    <div style={{ width: '100%', height: '338px' }}>
                      <BaselineVolumeLineChart
                        data={this.props?.baselineTotalDemand ? this.props?.baselineTotalDemand.data : []}
                        months={DATA.QUARTER_MONTHS}
                      />
                    </div>
                  </div>

                  <div className="baseline-table-container" style={{ width: '35%', flexGrow: 1 }}>
                    <span className="baseline-table-heading">Quarterly BL Full Year Volume</span>
                    <div style={{ width: '100%', height: '338px' }}>
                      <BaselineVolumeQtrLineChart
                        data={this.props?.baselineTotalDemand ? this.props?.baselineTotalDemand.data : []}
                        quarters={DATA.Quarterdata}
                      />
                    </div>
                  </div>

                </div>

                {/* ************ Time Line Graph section ************** */}

                <div className="baseline-table-container">
                  <span className="baseline-table-heading">Baseline vs Secondary Sales</span>
                  <div style={{ width: '100%', height: '330px' }}>
                    <BaselineTimeLineChart
                      data={this.props.baselineTotalDemandTimeline ? this.props.baselineTotalDemandTimeline.data : []}
                    />
                  </div>
                </div>

                <div className="baseline-table-container">
                  <span className="baseline-table-heading">Trend</span>
                  <div style={{ width: '100%', height: '330px' }}>
                    <BaselineTrendLineChart
                      data={this.props.baselineTotalDemandTimeline ? this.props.baselineTotalDemandTimeline.data : []}
                    />
                  </div>
                </div>

                <div className="baseline-table-container">
                  <span className="baseline-table-heading">Seasonal</span>
                  <div style={{ width: '100%', height: '330px' }}>
                    <BaselineSeasonalLineChart
                      data={this.props.baselineTotalDemandTimeline ? this.props.baselineTotalDemandTimeline.data : []}
                    />
                  </div>
                </div>

                <div className="baseline-table-container">
                  <span className="baseline-table-heading">Residual</span>
                  <div style={{ width: '100%', height: '330px' }}>
                    <BaselineResidualLineChart
                      data={this.props.baselineTotalDemandTimeline ? this.props.baselineTotalDemandTimeline.data : []}
                    />
                  </div>
                </div>

              </>
            )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    category: state.CategoryReducer.category,
    brands: state.BrandsReducer.brands,
    skus: state.SkusReducer.skus,
    isBaselineTotalDemandLoading: state.BaselineTotalDemandReducer.isBaselineTotalDemandLoading,
    baselineTotalDemand: state.BaselineTotalDemandReducer.baselineTotalDemand,
    isBaselineTotalDemandTimelineLoading: state.BaselineTotalDemandReducer.isBaselineTotalDemandTimelineLoading,
    baselineTotalDemandTimeline: state.BaselineTotalDemandReducer.baselineTotalDemandTimeline
  };
};

const mapDispatchToprops = (dispatch) => {
  return {
    getCategory: () => {
      return dispatch(CategoryMiddleware.getCategory());
    },
    getBrands: () => {
      return dispatch(BrandsMiddleware.getBrands());
    },
    getSkus: () => {
      return dispatch(SkusMiddleware.getSkus());
    },
    getBaselineTotalDemand: (
      selectedCategory,
      selectedBrand,
      selectedSku,
    ) => {
      return dispatch(
        BaselineTotalDemandMiddleware.getBaselineTotalDemand(
          selectedCategory,
          selectedBrand,
          selectedSku,
        )
      );
    },
    getBaselineTotalDemandTimeLine: (
      selectedCategory,
      selectedBrand,
      selectedSku,
    ) => {
      return dispatch(
        BaselineTotalDemandMiddleware.getBaselineTotalDemandTimeLine(
          selectedCategory,
          selectedBrand,
          selectedSku,
        )
      );
    }
  };
};

export default connect(mapStateToProps, mapDispatchToprops)(BaselineTotalDemand);
